import axios from "axios"

export default {
    async CariList(){
        const response = await axios.get(`/api/netsisaccountant/get/carilist`)
        return response
    },
    async KasaHareketList(){
        const response = await axios.get(`/api/netsisaccountant/get/kasahareketlist`)
        return response
    },
    async Kasa(type){
        const response = await axios.get(`/api/netsisaccountant/get/kasa/${type}`)
        return response
    },
    async CurrentUsersKasa(){
        const response = await axios.get(`/api/netsisaccountant/get/currentuserskasa`)
        return response
    },
    async CurrentUsersAuthCollarStatuses(){
        const response = await axios.get(`/api/netsisaccountant/userofnetsiskasa/collarstatusesbyauthnetsiskasa`)
        return response
    },
    GAvans:{
        async Assign(data){
            const response = await axios.post(`/api/netsisaccountant/gavans/assign`,data)
            return response
        },
    },
    GMaas:{
        async Pay(data){
            const response = await axios.post(`/api/netsisaccountant/gmaas/pay`,data)
            return response
        },
    },
    Cari:{
        async Table(data){
            const response = await axios.post(`/api/netsisaccountant/cari/table`,data)
            return response
        },
        async Detail(data){
            const response = await axios.post(`/api/netsisaccountant/cari/detay`,data)
            return response
        },
        async Stats(data){
            const response = await axios.get(`/api/netsisaccountant/cari/stats/${data}`)
            return response
        },
    },
    Report:{
        async getKasaReport(params) {
            const response = await axios.post(`/api/netsisaccountant/kasa/rapor`, params);
            return response;
        },
        async getKasaReportExcel(params) {
            const response = await axios.post(`/api/netsisaccountant/kasa/rapor/excel`, params);
            return response;
        },
        async getVaultList() {
            const response = await axios.get(`/api/netsisaccountant/get/kasalist`);
            return response;
        }
    },
}